import { LoadingOutlined } from '@ant-design/icons'

const LoadingIcon = LoadingOutlined

export default LoadingIcon
